module.exports = __webpack_public_path__ + "media/icons/map-icon-polygon-active-a3570c03.svg";